import { HubtypeAiProject } from 'models/hubtype-ai-project'

export interface AiState {
  readonly aiProjects: HubtypeAiProject[]
}

export const aiInitialState: AiState = Object.freeze({
  aiProjects: [],
})
